import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import {
  Div, InputWithLabel, Icon, Button, H4, SmallText, Checkbox, RadioGroup, CheckboxGroup, Input, P, Radio,
} from 'konsys-ui'
import {
  message, Row, Col, AutoComplete, Popover, notification, Select as Tag,
} from 'antd'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { Trash2 } from 'lucide-react'
import { CREATE_TIRE_INVENTORY, UPDATE_TIRE_INVENTORY } from '../../../constants/graph/mutation'
import {
  WAREHOUSE, SUPPLIERS, BRANDS, CATEGORIES, WAREHOUSES, VARIANTOPTIONSKEY, GET_OPTIONS, GET_TAGS, TIRE_INVENTORY, TIRETYPES, TIRE_INVENTORIES,
} from '../../../constants/graph/query'
import {
  FullPageContainer, Divider, SelectWithLabel, Select as KonsysSelect, DashedButton, Uploader, Log, Select,
} from '../../../components/common'
import { RadioWrapper } from '../styled'
import { theme } from '../../../styles/_variables'
import {
  SALE_TYPE, PRODUCT_GROUP, STOCK_TYPE, VAT_TYPE, detailMode,
} from '../constants'
import { verifyFields, checkFloat, checkInt } from '../../../utils/util-services'
import history from '../../../history'


const initialNewVariantData = {
  initialCost: undefined,
  initialStock: undefined,
  isVat: false,
}

const initialNewLocationData = {
  quantity: undefined,
  warehouseId: undefined,
  isNew: true,
}

const VariantOptionForm = ({
  inventoryOption, setInventoryOption, isCreateMode, data, warehousesData,
}) => (
    <Div>
      {
        inventoryOption.map((sku, index) => (
          <Div key={index} margin='40px 0 0 0'>
            <Div display='flex' width='100%' justifyContent='space-between' alignItems='center'>
              {
                isCreateMode
                  ? <P bold color={theme.color.primaryColor}>{sku.variantName}</P>
                  : <Input defaultValue={sku.variantName} onChange={(e) => {
                    setInventoryOption(inventoryOption.map((variant) => {
                      if (variant.id === sku.id) {
                        return ({
                          ...variant,
                          variantName: e.target.value,
                        })
                      } return variant
                    }))
                  }} />
              }
              {
                _.size(inventoryOption) > 1 && !_.includes(_.keys(sku), '__typename')
                && <Trash2 className='cursor-pointer text-gray-500' onClick={() => setInventoryOption(_.remove(_.cloneDeep(inventoryOption), o => o.id !== sku.id))} />
              }
            </Div>
            <Divider
              color={theme.color.veryLightBlue}
              margin='16px 0'
            />
            <Row style={{ margin: '8px 0' }}>
              <Col span={24}>
                <Uploader
                  // buttonText='อัพโหลดรูปประจำรุ่นสินค้า'
                  buttonText='อัพโหลดรูปสินค้า'
                  onChange={e => setInventoryOption(inventoryOption.map((val) => {
                    if (val.id === sku.id) {
                      return ({
                        ...val,
                        file: e,
                      })
                    }
                    return val
                  }))}
                  //  data={isCreateMode ? [] : sku.url }
                  data={isCreateMode || sku.file ? sku.file : sku.url ? [{ name: _.flatten(_.takeRight(_.split(sku.url, '/'))), uid: sku.url, url: sku.url }] : []}
                  isMultiple={false}
                  accept='image/*'
                />
              </Col>
            </Row>
            <Row type='flex' gutter={16} align='middle'>
              <Col
                xs={24}
                lg={6}
              >
                <SmallText bold>รหัสสินค้า *</SmallText>
                <Div display='flex' alignItems='center'>
                  <Input
                    width='100%'
                    defaultValue={isCreateMode ? undefined : sku.sku}
                    onChange={e => setInventoryOption(inventoryOption.map((val) => {
                      if (val.id === sku.id) {
                        return ({
                          ...val,
                          sku: e.target.value,
                        })
                      }
                      return val
                    }))}
                  />
                </Div>
              </Col>
              <Col
                xs={24}
                md={12}
                lg={6}
              >
                <SmallText bold>ต้นทุน *</SmallText>
                <Div display='flex' alignItems='center'>
                  <Input
                    width='100%'
                    type='number'
                    min='0'
                    step={0.01}
                    onKeyDown={e => !checkFloat(e) && e.preventDefault()}
                    disabled={!isCreateMode && !sku.isNew}
                    defaultValue={isCreateMode ? undefined : sku.initialCost}
                    onChange={e => setInventoryOption(inventoryOption.map((val) => {
                      if (val.id === sku.id) {
                        return ({
                          ...val,
                          initialCost: parseFloat(e.target.value),
                        })
                      }
                      return val
                    }))}
                  />
                </Div>
              </Col>
              <Col
                xs={24}
                md={12}
                lg={6}
              >
                {/* <Popover
              content={<P color={theme.color.error}>สต๊อกเริ่มต้นไม่เท่าสต๊อกในคลัง</P>}
              visible={sku.initialStock !== _.sum(sku.location.map(v => v.quantity))}
            > */}
                <SmallText bold>จำนวนสต๊อกเริ่มต้น *</SmallText>
                <Div display='flex' alignItems='center'>
                  <Input
                    width='100%'
                    type='number'
                    min='0'
                    step={1}
                    onKeyDown={e => !checkInt(e) && e.preventDefault()}
                    disabled={!isCreateMode && !sku.isNew}
                    defaultValue={isCreateMode ? undefined : sku.initialStock}
                    onChange={e => setInventoryOption(inventoryOption.map((val) => {
                      if (val.id === sku.id) {
                        return ({
                          ...val,
                          initialStock: parseInt(e.target.value, 10),
                        })
                      }
                      return val
                    }))}
                  />
                </Div>
                {/* </Popover> */}
              </Col>
              <Col
                xs={24}
                md={12}
                lg={6}
              >
                <SmallText bold>จำนวนสต๊อกขั้นต่ำ</SmallText>
                <Div display='flex' alignItems='center'>
                  <Input
                    width='100%'
                    type='number'
                    min='0'
                    step={1}
                    onKeyDown={e => !checkInt(e) && e.preventDefault()}
                    defaultValue={isCreateMode ? undefined : sku.minimumStock}
                    onChange={e => setInventoryOption(inventoryOption.map((val) => {
                      if (val.id === sku.id) {
                        return ({
                          ...val,
                          minimumStock: parseInt(e.target.value, 10),
                        })
                      }
                      return val
                    }))}
                  />
                </Div>
              </Col>
            </Row>
            <Row type='flex' gutter={16} align='middle'>
              <Col
                xs={24}
                md={12}
                lg={12}
              >
                <SmallText bold>ราคาซื้อสุทธิ</SmallText>
                <Div display='flex' alignItems='center'>
                  <Input
                    width='100%'
                    type='number'
                    min='0'
                    step={0.01}
                    onKeyDown={e => !checkFloat(e) && e.preventDefault()}
                    defaultValue={isCreateMode ? undefined : sku.buyPrice}
                    onChange={e => setInventoryOption(inventoryOption.map((val) => {
                      if (val.id === sku.id) {
                        return ({
                          ...val,
                          buyPrice: parseFloat(e.target.value),
                        })
                      }
                      return val
                    }))}
                  />
                </Div>
              </Col>
              <Col
                xs={24}
                md={12}
                lg={12}
              >
                <SmallText bold>ราคาขาย</SmallText>
                <Div display='flex' alignItems='center'>
                  <Input
                    width='100%'
                    type='number'
                    min='0'
                    step={0.01}
                    onKeyDown={e => !checkFloat(e) && e.preventDefault()}
                    defaultValue={isCreateMode ? undefined : sku.salesPrice}
                    onChange={e => setInventoryOption(inventoryOption.map((val) => {
                      if (val.id === sku.id) {
                        return ({
                          ...val,
                          salesPrice: parseFloat(e.target.value),
                        })
                      }
                      return val
                    }))}
                  />
                </Div>
              </Col>
            </Row>
            <Row type='flex' gutter={8} align='middle'>
              <Col
                span={12}
              >
                <SmallText bold>สถานที่จัดเก็บ *</SmallText>
              </Col>
              <Col
                span={6}
              >
                <SmallText bold>ชั้นวาง</SmallText>
              </Col>
              <Col
                span={5}
              >
                <SmallText bold>จำนวน *</SmallText>
              </Col>
              <Col span={1} />
            </Row>
            {
              sku.location.map(v => (
                <Row key={v.id} type='flex' gutter={8} align='middle' style={{ margin: '8px -8px' }}>
                  <Col
                    span={12}
                  >
                    <KonsysSelect
                      style={{ width: '100%' }}
                      onChange={(e) => {
                        const newLocations = sku.location.map((val) => {
                          if (val.id === v.id) return ({ ...v, warehouseId: e })
                          return val
                        })
                        setInventoryOption(inventoryOption.map((val) => {
                          if (val.id === sku.id) {
                            return { ...val, location: newLocations }
                          } return val
                        }))
                      }}
                      disabled={_.includes(_.keys(v), '__typename')}
                      placeholder='เลือกสถานที่จัดเก็บ'
                      defaultValue={isCreateMode || !v.warehouse ? undefined : v.warehouse.warehouseName}
                      options={
                        _.remove(_.cloneDeep(warehousesData.warehouseList.data.list), o => !_.includes(sku.location.map(location => location.warehouseId), o.id)).map(value => ({
                          value: value.id,
                          text: value.warehouseName,
                        }))
                      }
                    />
                  </Col>
                  <Col
                    span={6}
                  >
                    <Input
                      width='100%'
                      defaultValue={isCreateMode ? undefined : v.shelf}
                      placeholder='กรอกชั้นวาง'
                      onChange={(e) => {
                        const newLocations = sku.location.map((val) => {
                          if (val.id === v.id) return ({ ...v, shelf: e.target.value })
                          return val
                        })
                        setInventoryOption(inventoryOption.map((val) => {
                          if (val.id === sku.id) {
                            return { ...val, location: newLocations }
                          } return val
                        }))
                      }}
                    />
                  </Col>
                  <Col
                    span={5}
                  >
                    <Input
                      width='100%'
                      defaultValue={isCreateMode ? undefined : v.quantity}
                      disabled={!isCreateMode}
                      placeholder='กรอกจำนวน'
                      state='default'
                      rule={{ type: 'int' }}
                      onChange={(e) => {
                        const newLocations = sku.location.map((val) => {
                          if (val.id === v.id) return ({ ...v, quantity: parseInt(e.target.value, 10) })
                          return val
                        })
                        setInventoryOption(inventoryOption.map((val) => {
                          if (val.id === sku.id) {
                            return { ...val, location: newLocations }
                          } return val
                        }))
                      }}
                    />
                  </Col>
                  <Col span={1}>
                    {
                      (_.size(sku.location) > 1 && !_.includes(_.keys(v), '__typename'))
                      && <Trash2
                        className='cursor-pointer text-gray-500'
                        onClick={() => {
                          const newLocations = _.remove(_.cloneDeep(sku.location), o => o.id !== v.id)
                          setInventoryOption(inventoryOption.map((val) => {
                            if (val.id === sku.id) {
                              return { ...val, location: newLocations }
                            } return val
                          }))
                        }}
                      />
                    }
                  </Col>
                </Row>
              ))
            }
            <DashedButton width='100%' margin='16px 0 0 0' text='เพิ่มสถานที่จัดเก็บ' icon='fal fa-plus' onClick={() => setInventoryOption(inventoryOption.map((v) => {
              if (v.id === sku.id) {
                return ({
                  ...sku,
                  location: [...sku.location, { id: sku.location.length + 1, ...initialNewLocationData }],
                })
              } return v
            }))} />
          </Div>
        ))
      }
      {
        !isCreateMode
        && <Button
          // inverse
          // disabled={_.size(inventoryOption) > 2}
          width='100%'
          margin='32px 0'
          text='เพิ่มรุ่น'
          onClick={() => {
            setInventoryOption(
              _.concat(
                inventoryOption,
                {
                  isNew: true,
                  id: _.maxBy(inventoryOption, 'id').id + 1,
                  location: [{
                    id: 1,
                    ...initialNewLocationData,
                  }],
                },
              ),
            )
            // inventoryOption.map(v => ([...v, { id: _.maxBy(inventoryOption, 'id').id + 1 }])))
            // { ...v, pack: [...v.pack, { id: _.maxBy(v.pack, 'id').id + 1 }] })))
          }} />
      }
    </Div>
)

const Form = ({
  loading, isCreateMode, data, id,
}) => {
  const { loading: supLoading, data: supData, error: supError } = useQuery(SUPPLIERS)
  // const { loading: cateLoading, data: cateData, error: cateError } = useQuery(CATEGORIES)
  const { loading: tireTypeLoading, data: tireTypeData, error: tireTypeError } = useQuery(TIRETYPES)
  const { loading: brandsLoading, data: brandsData, error: brandsError } = useQuery(BRANDS)
  const { loading: warehousesLoading, data: warehousesData, error: warehousesError } = useQuery(WAREHOUSES)
  const [doAction, { loading: mutationLoading }] = useMutation(isCreateMode ? CREATE_TIRE_INVENTORY : UPDATE_TIRE_INVENTORY)

  const [mutationVariables, setMutationVariables] = useState(
    isCreateMode
      ? {
        type: SALE_TYPE.VARIANT,
        tag: [],
        sellable: true,
        purchasable: true,
        taxable: true,
        serialTracking: true,
        stockType: STOCK_TYPE.STOCK,
        productGroup: PRODUCT_GROUP.TIRES,
      }
      : {
        type: SALE_TYPE.VARIANT,
        tag: [],
        sellable: true,
        purchasable: true,
        taxable: true,
        serialTracking: true,
        stockType: STOCK_TYPE.STOCK,
        productGroup: PRODUCT_GROUP.TIRES,
      },
  )
  const [suppliers, setSuppliers] = useState([{ id: 1, supplierId: undefined }])
  const [variants, setVariants] = useState([
    { id: 1, option: 'Width', value: [] },
    { id: 2, option: 'Series', value: [] },
    { id: 3, option: 'Rims', value: [] },
  ])
  const [packs, setPacks] = useState([{ id: 1, option: undefined, value: [] }])
  const [inventoryOption, setInventoryOption] = useState([])
  const [isAutomateSKU, setIsAutomateSKU] = useState(false)
  const [buyPrice, setBuyPrice] = useState(0)
  const [salesPrice, setSalesPrice] = useState(0)
  const [minimumStock, setMinimumStock] = useState(0)
  const [file, setFile] = useState()

  useEffect(() => {
    if (!isCreateMode && !loading) {
      setMutationVariables({
        ...mutationVariables,
        ...data.TireInfo,
        tireTypeId: !_.isNull(data.TireInfo.Tire) ? data.TireInfo.Tire.TireType.id : null,
      })
      setInventoryOption(data.TireInfo.inventoryOptions.map(v => ({
        ...v,
      })))
      setSuppliers(data.TireInfo.supplier.map(v => ({ ...v, supplierId: v.id })))
      if (data.TireInfo.inventoryOptions[0]) {
        setFile(data.TireInfo.inventoryOptions[0].url ? [{ name: _.flatten(_.takeRight(_.split(data.TireInfo.inventoryOptions[0].url, '/'))), uid: data.TireInfo.inventoryOptions[0].url, url: data.TireInfo.inventoryOptions[0].url }] : undefined)
        setBuyPrice(data.TireInfo.inventoryOptions[0].buyPrice)
        setSalesPrice(data.TireInfo.inventoryOptions[0].salesPrice)
        setMinimumStock(data.TireInfo.inventoryOptions[0].minimumStock)
        setVariants([
          { id: 1, option: 'Width', value: data.TireInfo.inventoryOptions[0].option1 ? data.TireInfo.inventoryOptions[0].option1.optionName : null },
          { id: 2, option: 'Series', value: data.TireInfo.inventoryOptions[0].option2 ? data.TireInfo.inventoryOptions[0].option2.optionName : null },
          { id: 3, option: 'Rims', value: data.TireInfo.inventoryOptions[0].option3 ? data.TireInfo.inventoryOptions[0].option3.optionName : null }])
      }
    }
  }, [loading])

  const isPassed = verifyFields(
    isCreateMode,
    [
      mutationVariables.sku,
      suppliers,
      mutationVariables.productName,
      mutationVariables.productGroup,
      mutationVariables.stockType,
      mutationVariables.tireTypeId,
      variants[0].value,
      mutationVariables.unit,
      mutationVariables.technicianName,
    ],
    { ...mutationVariables },
  )

  return (
    <Div>
      {
        !loading
          ? !isCreateMode && _.isNull(data.TireInfo)
            ? <H4>ไม่พบ</H4>
            : <Div display='flex' flexDirection='column'>
              <SmallText bold>Supplier *</SmallText>
              {
                suppliers.map((v, i) => (
                  <Row type='flex' gutter={16} align='middle' key={i} style={{ margin: '16px -8px 0 -8px' }}>
                    <Col span={23}>
                      <KonsysSelect
                        style={{ width: '100%' }}
                        placeholder='เลือก Supplier ของสินค้า'
                        value={(supLoading || _.isUndefined(v.supplierId)) ? undefined : _.find(supData.supplierList.data.list, o => o.id === v.supplierId).name}
                        onChange={(e) => {
                          setSuppliers(suppliers.map((val) => {
                            if (v.id === val.id) return { ...val, supplierId: e }
                            return val
                          }))
                        }}
                        options={supLoading ? [] : _.remove(_.cloneDeep(supData.supplierList.data.list), o => !_.includes(suppliers.map(sup => sup.supplierId), o.id)).map(supp => ({ value: supp.id, text: supp.name }))}
                      />
                    </Col>
                    <Col span={1}>
                      {i > 0 && <Trash2 className='cursor-pointer text-gray-500' onClick={() => setSuppliers(_.remove(_.cloneDeep(suppliers), o => o.id !== v.id))} />}
                    </Col>
                  </Row>
                ))
              }
              <DashedButton icon='fal fa-plus' onClick={() => setSuppliers([...suppliers, { id: _.maxBy(suppliers, 'id').id + 1, supplierId: undefined }])} text='เพิ่ม Supplier' small margin='16px 0 8px' />
              <Row type='flex' gutter={16} align='middle'>
                <Col
                  xs={24}
                  md={12}
                >
                  <Div>
                    <SmallText bold>ชื่อสินค้า *</SmallText>
                    <Div display='flex' alignItems='center'>
                      <Input
                        width='100%'
                        value={mutationVariables.productName}
                        // defaultValue={isCreateMode ? undefined : data.TireInfo.sku}
                        onChange={e => setMutationVariables({ ...mutationVariables, productName: e.target.value })}
                      />
                    </Div>
                  </Div>
                </Col>
                <Col
                  xs={24}
                  md={6}
                >
                  <Div>
                    <SmallText bold>ชื่อที่ช่างเรียก *</SmallText>
                    <Div display='flex' alignItems='center'>
                      <Input
                        width='100%'
                        value={mutationVariables.technicianName}
                        onChange={e => setMutationVariables({ ...mutationVariables, technicianName: e.target.value })}
                      />
                    </Div>
                  </Div>
                </Col>
                <Col
                  xs={24}
                  md={6}
                >
                  <Div>
                    <SmallText bold>หน่วย *</SmallText>
                    <Div display='flex' alignItems='center'>
                      <Input
                        width='100%'
                        value={mutationVariables.unit}
                        onChange={e => setMutationVariables({ ...mutationVariables, unit: e.target.value })}
                      />
                    </Div>
                  </Div>
                </Col>
              </Row>
              <Row type='flex' gutter={16} align='middle'>
                <Col
                  xs={24}
                  md={6}
                >
                  <Div>
                    <SmallText bold>รหัสสินค้า *</SmallText>
                    <Div display='flex' alignItems='center'>
                      <Input
                        width='100%'
                        value={mutationVariables.sku}
                        disabled={isAutomateSKU}
                        // defaultValue={isCreateMode ? undefined : data.TireInfo.sku}
                        onChange={e => setMutationVariables({ ...mutationVariables, sku: e.target.value })}
                      />
                    </Div>
                  </Div>
                </Col>
                <Col
                  xs={24}
                  md={6}
                >
                  <SelectWithLabel
                    width='100%'
                    title={{
                      text: 'ยี่ห้อ',
                    }}
                    select={{
                      style: { width: '100%' },
                      value: mutationVariables.brand,
                      placeholder: 'เลือกยี่ห้อ',
                      onChange: e => setMutationVariables({ ...mutationVariables, brand: e }),
                      options: brandsLoading ? [] : brandsData.getBrandList.data.map(v => ({ value: v, text: v })),
                    }}
                  />
                </Col>
                <Col
                  xs={24}
                  md={12}
                >
                  <SelectWithLabel
                    width='100%'
                    title={{
                      text: 'ประเภทยาง *',
                    }}
                    select={{
                      style: { width: '100%' },
                      value: mutationVariables.tireTypeId,
                      placeholder: 'เลือกประเภทยาง',
                      onChange: e => setMutationVariables({ ...mutationVariables, tireTypeId: e }),
                      options: tireTypeLoading ? [] : tireTypeData.TireTypeList.lists.map(v => ({ text: v.name, value: v.id })),
                    }}
                  />
                </Col>
              </Row>
              <Row type='flex' gutter={16} align='middle'>
                <Col
                  xs={12}
                  md={6}
                >
                  <Div>
                    <SmallText bold>หน้ายาง *</SmallText>
                    <Div display='flex' alignItems='center'>
                      <Input
                        width='100%'
                        value={variants[0].value}
                        // defaultValue={isCreateMode ? undefined : data.TireInfo.sku}
                        onChange={e => setVariants(variants.map((val) => {
                          if (val.id === 1) {
                            return ({
                              ...val,
                              value: [e.target.value],
                            })
                          } return val
                        }))}
                      />
                    </Div>
                  </Div>
                </Col>
                <Col
                  xs={12}
                  md={6}
                >
                  <Div>
                    <SmallText bold>แก้มยาง</SmallText>
                    <Div display='flex' alignItems='center'>
                      <Input
                        width='100%'
                        value={variants[1].value}
                        // defaultValue={isCreateMode ? undefined : data.TireInfo.sku}
                        onChange={e => setVariants(variants.map((val) => {
                          if (val.id === 2) {
                            return ({
                              ...val,
                              value: [e.target.value],
                            })
                          } return val
                        }))}
                      />
                    </Div>
                  </Div>
                </Col>
                <Col
                  xs={12}
                  md={6}
                >
                  <Div>
                    <SmallText bold>กะทะล้อ</SmallText>
                    <Div display='flex' alignItems='center'>
                      <Input
                        width='100%'
                        value={variants[2].value}
                        // defaultValue={isCreateMode ? undefined : data.TireInfo.sku}
                        onChange={e => setVariants(variants.map((val) => {
                          if (val.id === 3) {
                            return ({
                              ...val,
                              value: [e.target.value],
                            })
                          } return val
                        }))}
                      />
                    </Div>
                  </Div>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  lg={6}
                >
                  <SmallText bold>จำนวนสต๊อกขั้นต่ำ</SmallText>
                  <Div display='flex' alignItems='center'>
                    <Input
                      width='100%'
                      type='number'
                      min='0'
                      step={1}
                      onKeyDown={e => !checkInt(e) && e.preventDefault()}
                      defaultValue={isCreateMode || !data.TireInfo.inventoryOptions[0] ? undefined : data.TireInfo.inventoryOptions[0].minimumStock}
                      onChange={e => setMinimumStock(e.target.value)}
                    />
                  </Div>
                </Col>
              </Row>
              <Row type='flex' gutter={16} align='middle'>
                <Col
                  xs={24}
                  md={12}
                  lg={12}
                >
                  <SmallText bold>ราคาซื้อสุทธิ</SmallText>
                  <Div display='flex' alignItems='center'>
                    <Input
                      width='100%'
                      type='number'
                      min='0'
                      step={0.01}
                      onKeyDown={e => !checkFloat(e) && e.preventDefault()}
                      defaultValue={isCreateMode || !data.TireInfo.inventoryOptions[0] ? undefined : data.TireInfo.inventoryOptions[0].buyPrice}
                      onChange={e => setBuyPrice(e.target.value)}
                    />
                  </Div>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  lg={12}
                >
                  <SmallText bold>ราคาขาย</SmallText>
                  <Div display='flex' alignItems='center'>
                    <Input
                      width='100%'
                      type='number'
                      min='0'
                      step={0.01}
                      onKeyDown={e => !checkFloat(e) && e.preventDefault()}
                      defaultValue={isCreateMode || !data.TireInfo.inventoryOptions[0] ? undefined : data.TireInfo.inventoryOptions[0].salesPrice}
                      onChange={e => setSalesPrice(e.target.value)}
                    />
                  </Div>
                </Col>
              </Row>
              <Row style={{ margin: '8px 0' }}>
                <Col span={24}>
                  <Uploader
                    // buttonText='อัพโหลดรูปประจำรุ่นสินค้า'
                    buttonText='อัพโหลดรูปสินค้า'
                    onChange={e => setFile(e)}
                    data={file}
                    isMultiple={false}
                    accept='image/*'
                  />
                </Col>
              </Row>
              <Div display='flex' flexDirection='row' justifyContent='center' alignItems='center' width='100%' margin='20px 0'>
                <Link to='/tire-inventory'>
                  <Button
                    color={theme.color.error}
                    loading={mutationLoading}
                    text='ยกเลิก'
                    icon='fal fa-times'
                    style={{ alignItems: 'center' }}
                    width='fit-content'
                    margin='0 4px'
                  />
                </Link>
                <Button
                  loading={mutationLoading}
                  disabled={isPassed}
                  text={isCreateMode ? 'สร้างสินค้าใหม่' : 'แก้ไขสต๊อกสินค้า'}
                  rightIcon={true}
                  icon={isCreateMode ? 'fal fa-plus' : 'fal fa-edit'}
                  style={{ alignItems: 'center' }}
                  width='fit-content'
                  margin='0 4px'
                  onClick={() => {
                    if (isCreateMode) {
                      // const prepare = variants.map(variant => (
                      //   variant.value.map(val => (val))
                      // ))
                      // const inventory = prepare.reduce((a, b) => a.reduce((r, v) => r.concat(b.map(w => [].concat(v, w))), [])).map(v => _.omitBy((
                      const prepare = [variants.map(variant => (
                        variant.value[0]
                      ))]
                      const inventory = prepare.map(v => _.omitBy((
                        {
                          id: _.join(v, ' / '),
                          variantName: _.join(v, ' / '),
                          optionKey1: variants[0] ? variants[0].option : null,
                          optionName1: v[0] ? v[0] : null,
                          optionKey2: variants[1] ? variants[1].option : null,
                          optionName2: v[1] ? v[1] : null,
                          optionKey3: variants[2] ? variants[2].option : null,
                          optionName3: v[2] ? v[2] : null,

                          ...initialNewVariantData,
                        }
                      ), o => _.isNull(o)))
                      doAction({
                        variables: {
                          ...mutationVariables,
                          supplierId: suppliers.map(v => v.supplierId),
                          inventoryOption: inventory.map(v => (_.omit({
                            ...v,
                            file: file ? file[0] : undefined,
                            minimumStock: parseInt(minimumStock, 10),
                            salesPrice: parseFloat(salesPrice, 10),
                            buyPrice: parseFloat(buyPrice, 10),
                            initialStock: 0,
                          }, ['id', 'variantName']))),
                        },
                        refetchQueries: [{ query: TIRE_INVENTORIES, variables: { limit: 5, offset: 0 } }],
                      }).then((resp) => {
                        const KEY = isCreateMode ? 'createInventoryForTire' : 'c'
                        if (resp.data[KEY].success) {
                          message.success(resp.data[KEY].message)
                          history.push('/tire-inventory')
                        } else message.error(resp.data[KEY].message)
                      })
                    } else {
                      doAction({
                        variables: _.omit({
                          ...mutationVariables,
                          tag: mutationVariables.tag.map(v => ({ name: v.name })),
                          supplierId: suppliers.map(v => v.supplierId),
                          inventoryOption: inventoryOption.map(v => ({
                            id: v.id,
                            variantName: v.variantName,
                            sku: v.sku,
                            minimumStock: parseInt(minimumStock, 10),
                            initialStock: v.initialStock,
                            salesPrice: parseFloat(salesPrice, 10),
                            buyPrice: parseFloat(buyPrice, 10),
                            vat: v.vat,
                            file: _.isNull(v.url) && !_.isEmpty(file) ? file[0] : null,
                            width: variants[0].value[0],
                            series: variants[1].value ? variants[1].value[0] : null,
                            rim: variants[2].value[0],
                            // location: v.location.map(location => ({
                            //   locationId: _.includes(location.id, '_NEW') || location.isNew ? undefined : location.id, warehouseId: location.warehouseId, shelf: location.shelf, quantity: location.quantity,})),
                          })),
                        }, ['initialCost', 'inventoryOptions', 'supplier', 'type', '__typename']),
                        refetchQueries: [{ query: TIRE_INVENTORIES, variables: { limit: 5, offset: 0 } }],
                      }).then((resp) => {
                        const KEY = isCreateMode ? 'createInventoryForTire' : 'updateInventoryTire'
                        if (resp.data[KEY].success) {
                          message.success(resp.data[KEY].message)
                          history.push('/tire-inventory')
                        } else message.error(resp.data[KEY].message)
                      })
                    }
                  }
                  }
                />
              </Div>
            </Div>
          : null
      }
    </Div>
  )
}

export default ({ props }) => {
  const isCreateMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const { loading, data, error } = useQuery(TIRE_INVENTORY, { skip: isCreateMode, variables: { id: props.match.params.id } })

  return <Form data={data} loading={loading} isCreateMode={isCreateMode} id={parseInt(props.match.params.id, 10)} />
}
